import { message, Modal, Radio, Typography } from "antd";
import React, { FC, useState } from "react";
import { EDITABLE_BASIC_STATUSES } from "./constant";
import { VendorListItem } from "./interface";

type EditScope = "basic" | "non-basic";

interface Props {
  visible: boolean;
  vendor: VendorListItem;
  onClose: () => void;
}

const EditScopeModal: FC<Props> = ({ visible, vendor, onClose }) => {
  const { id: vendorId, applicationStatus, sourceId } = vendor;
  const canEditBasic = EDITABLE_BASIC_STATUSES.includes(applicationStatus);
  const [scope, setScope] = useState<EditScope | undefined>(undefined);

  const handleOnClose = () => {
    setScope(undefined);
    onClose();
  };

  const handleNext = () => {
    if (!scope) {
      message.warning("請先選擇編輯範疇");
      return;
    }
    window.open(`/vendor/info/${vendorId}?mode=${scope}`, "_blank");
    handleOnClose();
  };

  return (
    <Modal open={visible} onOk={handleNext} onCancel={handleOnClose} okText="下一步" cancelText="取消">
      <Typography.Title level={5}>請選擇編輯範疇</Typography.Title>
      <Radio.Group value={scope} onChange={(e) => setScope(e.target.value)}>
        <Radio value="basic" disabled={!canEditBasic} style={{ display: "block", marginBottom: 8 }}>
          廠商基本資料（需要重跑申請流程）
        </Radio>
        <Radio value="non-basic" disabled={!sourceId} style={{ display: "block" }}>
          非廠商基本資料（可以直接更新）
        </Radio>
      </Radio.Group>
    </Modal>
  );
};

export default EditScopeModal;
